import { Component } from '@angular/core';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';

@Component({
  standalone: true,
  imports: [FusePerfectScrollbarDirective],
  selector: 'app-dialog-rassegna-stampa',
  templateUrl: './dialog-rassegna-stampa.component.html',
  styleUrls: ['./dialog-rassegna-stampa.component.scss']
})
export class DialogRassegnaStampaComponent {}
